'use client';
import { responsiveModifierSet, isValidStyleProperty, isResponsiveModifier, getKey } from './swan-style.utils.js';
import { iterToSet } from './transform.utils.js';

function getClassName(t, s, r = 'xs') {
    if (null == s) return null;
    let n = getKey(t);
    if (!n) return null;
    let l = `swan-${n}`, a = 'xs' === r ? '' : `-${r}`;
    return 'boolean' == typeof s ? s ? l + a : null : l + `-${s}` + a;
}
function updateClassNameSet(e, t, s, r) {
    let n = getClassName(e, t, s);
    return n && r.add(n), r;
}
function processResponsiveStyleProps(e, r, n = new Set()) {
    return Object.keys(e).forEach((l)=>{
        if (!isValidStyleProperty(l)) return null;
        if ('object' == typeof e[l]) {
            let s = e[l];
            Object.keys(s).forEach((e)=>{
                isResponsiveModifier(e) && updateClassNameSet(l, s[e], e, n);
            });
        } else updateClassNameSet(l, e[l], r, n);
    }), n;
}
function processStyleProps(e, t) {
    let s = iterToSet(t);
    if (e.swanStyle) {
        let t = e.swanStyle;
        responsiveModifierSet.forEach((e)=>{
            let r = t[e];
            r && (s = processResponsiveStyleProps(r, e, s));
        }), s = processResponsiveStyleProps(e.swanStyle, 'xs', s);
    }
    return processResponsiveStyleProps(e, 'xs', s), s;
}
function camelToKebabCase(e) {
    return e ? e.replace(/[A-Z]/g, (e)=>`-${e.toLowerCase()}`) : '';
}
function generateStyleClassName(e) {
    let { propKey: t, propValue: s, breakpoint: r = 'xs', classNamePrefix: n } = e;
    if ('string' != typeof s && 'number' != typeof s && true !== s) return;
    let l = [
        'swan'
    ];
    return n && l.push(n), l.push(camelToKebabCase(t)), true !== s && l.push(s), 'xs' !== r && l.push(r), l.join('-');
}
function generateResponsiveClassNames(e, s) {
    let r = new Set();
    for(let n in e){
        let l = e[n];
        if (null != l && false !== l) {
            if ('object' != typeof l || Array.isArray(l)) {
                let e = generateStyleClassName({
                    propKey: n,
                    propValue: l,
                    classNamePrefix: s
                });
                e && r.add(e);
                continue;
            }
            for(let e in l){
                if (!isResponsiveModifier(e)) continue;
                let a = generateStyleClassName({
                    propKey: n,
                    propValue: l[e],
                    breakpoint: e,
                    classNamePrefix: s
                });
                a && r.add(a);
            }
        }
    }
    return r;
}

export { camelToKebabCase, generateResponsiveClassNames, generateStyleClassName, processStyleProps };
